module.exports = __webpack_public_path__ + "img/entertainment.e23cae10.png";